/* innate-about-values-20260817: smooth open/close for the About values list.

   A native <details> cannot animate its own collapse — the moment `open` is
   removed the browser hides the content, so there is nothing left to transition.
   The fix is to own the timing: on close, animate the wrapper down to zero
   first and only drop `open` once the animation has finished.

   Everything here is an enhancement. The markup is a plain <details> list that
   works with the script blocked, failed or still loading; all this adds is the
   height animation and the one-at-a-time behaviour. The bodies are server
   rendered either way, so nothing here affects what a crawler sees.
*/
(function () {
  var lists = document.querySelectorAll('.about-overhaul__value-list');
  if (!lists.length) { return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 420;
  var EASE = 'cubic-bezier(.22, .61, .36, 1)';

  function reveal(details) {
    return details.querySelector('.about-overhaul__value-reveal');
  }

  function expand(details) {
    var box = reveal(details);
    if (!box) { details.open = true; return; }

    details.open = true;

    if (reduce) { box.style.height = ''; return; }

    details.dataset.animating = '1';
    box.style.height = '0px';
    /* Read back before changing the value again, otherwise the browser
       coalesces both writes into one frame and no transition runs. */
    void box.offsetHeight;
    box.style.transition = 'height ' + DURATION + 'ms ' + EASE;
    box.style.height = box.scrollHeight + 'px';

    window.setTimeout(function () {
      /* Back to auto once settled, so the row reflows correctly when the
         viewport changes or a lazy image finally arrives. */
      box.style.transition = '';
      box.style.height = '';
      details.dataset.animating = '0';
    }, DURATION);
  }

  function collapse(details) {
    var box = reveal(details);
    if (!box) { details.open = false; return; }

    if (reduce) { details.open = false; box.style.height = '0px'; return; }

    details.dataset.animating = '1';
    box.style.height = box.scrollHeight + 'px';
    void box.offsetHeight;
    box.style.transition = 'height ' + DURATION + 'ms ' + EASE;
    box.style.height = '0px';

    window.setTimeout(function () {
      details.open = false;
      box.style.transition = '';
      details.dataset.animating = '0';
    }, DURATION);
  }

  Array.prototype.forEach.call(lists, function (list) {
    var items = list.querySelectorAll('.about-overhaul__value');
    if (!items.length) { return; }

    list.classList.add('is-enhanced');

    Array.prototype.forEach.call(items, function (details) {
      var summary = details.querySelector('summary');
      var box = reveal(details);
      if (!summary || !box) { return; }

      if (!details.open) { box.style.height = '0px'; }

      summary.addEventListener('click', function (event) {
        /* The script owns the toggle from here — the native one would flip
           `open` instantly and there would be nothing left to animate.
           Keyboard Enter and Space both arrive as clicks on a summary, so
           this covers them too. */
        event.preventDefault();

        if (details.dataset.animating === '1') { return; }

        if (details.open) {
          collapse(details);
          return;
        }

        Array.prototype.forEach.call(items, function (other) {
          if (other !== details && other.open && other.dataset.animating !== '1') {
            collapse(other);
          }
        });

        expand(details);
      });
    });
  });
}());
